/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Recovery_Codes_CopyInputs */

const en_recovery_codes_copy = /** @type {(inputs: Recovery_Codes_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy`)
};

const de_recovery_codes_copy = /** @type {(inputs: Recovery_Codes_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopieren`)
};

/**
* | output |
* | --- |
* | "Copy" |
*
* @param {Recovery_Codes_CopyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const recovery_codes_copy = /** @type {((inputs?: Recovery_Codes_CopyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recovery_Codes_CopyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_recovery_codes_copy(inputs)
	return en_recovery_codes_copy(inputs)
});